// Grille partagée : tout le monde calcule la même position à partir de l'horloge serveur.
const EPOCH = Date.UTC(2026, 0, 1) / 1000;

export function locate(manifest, nowSec) {
  const { items, jingle } = manifest;
  const cycle = items.reduce((s, it) => s + it.d + jingle, 0);
  let t = (((nowSec - EPOCH) % cycle) + cycle) % cycle;
  for (let i = 0; i < items.length; i++) {
    const next = (i + 1) % items.length;
    if (t < items[i].d) return { kind: "episode", idx: i, offset: t, length: items[i].d, nextIdx: next };
    t -= items[i].d;
    if (t < jingle) return { kind: "jingle", idx: next, offset: t, length: jingle, nextIdx: next };
    t -= jingle;
  }
  return { kind: "episode", idx: 0, offset: 0, length: items[0].d, nextIdx: 1 % items.length };
}

// Nombre d'auditeurs fictif, identique pour tous à la minute près.
export function listenersAt(nowSec) {
  const h = new Date(nowSec * 1000).getUTCHours() + 1;
  const wave = 0.55 + 0.45 * Math.sin(((h - 9) / 24) * Math.PI * 2);
  const m = Math.floor(nowSec / 60);
  const noise = ((m * 9301 + 49297) % 233280) / 233280;
  return Math.round(38 + wave * 64 + noise * 9);
}

export const fmt = (s) => {
  const v = Math.max(0, Math.floor(s));
  return `${Math.floor(v / 60)}:${String(v % 60).padStart(2, "0")}`;
};
